"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.season_compare = exports.tour_reservation_snapshot = void 0;
exports.tour_reservation_snapshot = "/api/v2/tours/reservations/{reservation_id}/snapshot";
exports.season_compare = "/api/v2/tours/seasons/{season_id}/compare{?selectedSeasonId}";
